'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { ColorSwatchLabelPositions, ColorSwatchGradientTypes, useColorSwatchesContext } from './color-swatches.context.js';
import { createComponent } from '../core/create-component.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
let a = {
    primaryColor: e$1.string,
    secondaryColor: e$1.string,
    backgroundImage: e$1.string,
    disabled: e$1.bool,
    accessibleText: e$1.string,
    labelPosition: e$1.oneOf(ColorSwatchLabelPositions),
    gradient: e$1.oneOf(ColorSwatchGradientTypes)
}, i = Object.keys(a).filter((e)=>'title' !== e);
function getBackgroundUrl(e) {
    let r = (null == e ? void 0 : e.startsWith('"')) ? '' : '"';
    return e ? `url(${r}${e}${r})` : void 0;
}
const ColorSwatch = createComponent({
    displayName: 'ColorSwatch',
    root: 'div',
    propTypes: a,
    propKeysToRemove: i,
    propConfig: {
        processProps (e) {
            var { style: r = {}, primaryColor: t = 'transparent', secondaryColor: o, accessibleText: n, backgroundImage: c, title: l, disabled: a = !1 } = e, i = _object_without_properties(e, [
                "style",
                "primaryColor",
                "secondaryColor",
                "accessibleText",
                "backgroundImage",
                "title",
                "disabled"
            ]);
            let p = useColorSwatchesContext();
            return _object_spread_props(_object_spread({
                labelPosition: null == p ? void 0 : p.labelPosition
            }, i), {
                'aria-disabled': !!a,
                accessibleText: null != n ? n : l,
                title: void 0,
                disabled: a,
                role: 'presentation',
                style: _object_spread_props(_object_spread({}, r), {
                    backgroundColor: null !== t ? t : void 0,
                    color: null != o ? o : void 0,
                    backgroundImage: getBackgroundUrl(c)
                })
            });
        },
        classNames (e) {
            let r = new Set([
                'swan-color-swatch'
            ]), { disabled: t, gradient: o } = e;
            return t && r.add("swan-color-swatch-disabled"), o && r.add(`swan-color-swatch-${o}-gradient`), r;
        },
        wrapRoot ({ accessibleText: e$1, labelPosition: o }, c, l) {
            if (null === e$1) return l;
            let s = className([
                'swan-color-swatch-accessible-label',
                o && 'top' !== o ? `swan-color-swatch-accessible-label-${o}` : void 0
            ]);
            return e.createElement("span", {
                className: "swan-color-swatch-wrapper"
            }, l, e.createElement(VisuallyHidden, {
                className: s
            }, e$1));
        }
    }
});

export { ColorSwatch };
